import React from "react";
import Select from "react-select";
import { IDropdownOptionsModel } from "../models/CommonFields";

interface ISearchableDropdownProps {
  options: IDropdownOptionsModel[];
  id?: string;
  name?: string;
  className?: string;
  defaultValue?: [];
  value?: any;
  isMulti?: boolean;
  handleChange?: Function;
  handleBlur?: Function;
  disabled?: boolean;
  placeholder?: string;
  classNamePrefix?: string;
  isClearable?: boolean;
  labelValue?: string;
}

const SearchableDropdown = (props: ISearchableDropdownProps) => {
  const {
    id,
    name,
    className,
    options,
    defaultValue,
    value,
    isMulti,
    handleChange,
    handleBlur,
    disabled,
    placeholder,
    isClearable,
    classNamePrefix,
    labelValue,
  } = props;

  return (
    <div className="dropdown-search">
      <Select
        id={id || "select"}
        name={name || "select"}
        className={className}
        options={options}
        defaultValue={defaultValue}
        value={value}
        onChange={(e: any) => handleChange && handleChange(e, labelValue)}
        onBlur={handleBlur}
        isDisabled={disabled}
        placeholder={placeholder}
        isClearable={isClearable}
        classNamePrefix={classNamePrefix}
        isMulti={isMulti}
      />
    </div>
  );
};

export default SearchableDropdown;
